"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.exampleStyles = void 0;
/**
 * Example styles for CoralMap
 */
var exampleStyles = exports.exampleStyles = {
  textColor: "white",
  nodeColor: "black",
  branchColor: "black",
  atypicalLabel: {
    textSize: '9px'
  },
  typicalLabel: {
    textSize: '12px'
  },
  label: {
    textColor: 'blue'
  },
  TK: {
    branchColor: "orange",
    nodeColor: "orange",
    label: {
      textSize: '20px',
      textColor: "orange"
    }
  },
  BARK2: {
    branchColor: "red",
    nodeColor: "red",
    nodeSize: 8,
    textSize: "4px",
    textColor: "black"
  },
  AGC: {
    branchColor: "rgba(0,0,0,0)",
    nodeColor: "rgba(0,0,0,0)",
    textColor: "rgba(0,0,0,0)",
    label: {
      textColor: "rgba(0,0,0,0)"
    }
  },
  Alpha: {
    branchColor: "green",
    nodeColor: "green",
    label: {
      textColor: "green"
    }
  }
};